import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from "react-router-dom";
import './styles/Navigation.css';
function NavigationButtons({setBusqueda, state}) {
  return (
    
    <div className="navigation">
        <button type="button"
            onClick={ ()=> setBusqueda( { investigador: true,centro: false } )}
            className="sui-search-box__submit sui-search-box__submit--tabs"
            >
                Investigadores
        </button>

        <button type="button"
        onClick={ ()=> setBusqueda( { investigador: false,centro: true } )}
        className="sui-search-box__submit sui-search-box__submit--tabs"
        >
            Centros
        </button>
    </div>
  );
}

NavigationButtons.prototype = {
  setBusqueda: PropTypes.func.isRequired,
  state: PropTypes.object.isRequired
}

export default withRouter(NavigationButtons);
